import React from 'react';
import JobBoardPage from './jobs/JobBoardPage';

/** The home page is the job board. */
const HomePage: React.FC = () => <JobBoardPage />;

export default HomePage;
